import React from "react";
import PolicyPage from "../policies/PolicyPage";
const sections = [
  {
    id: "section-1",
    title: "Product information",
    paragraphs: [
      "Product descriptions, photographs and specifications help you identify suitable products. Check the model, version, dimensions, connections and compatibility before ordering. Photographs may show a particular configuration; the specification agreed for your order determines what is supplied.",
      "Contact us if a listing appears incomplete or inaccurate. A product marked “Request a quote” does not have a confirmed online purchase price.",
    ],
  },
  {
    id: "section-2",
    title: "Technical guidance and safety",
    paragraphs: [
      "General website information is not a substitute for an assessment of your particular machine or installation. Repairs, electrical work and installation should be carried out by appropriately qualified personnel following the relevant manufacturer’s instructions.",
    ],
  },
  {
    id: "section-3",
    title: "Machine configurations and quotations",
    paragraphs: [
      "The machine builder records your preferences. Preparing a request does not submit an order or guarantee that the selected components are compatible or available. Send the request to our team for confirmation of specifications, price, installation and delivery.",
      "Published features do not guarantee earnings, revenue or a particular business outcome. Operators are responsible for obtaining the permissions required for their premises and activities.",
    ],
  },
  {
    id: "section-4",
    title: "Currency and delivery estimates",
    paragraphs: [
      "USD is the checkout currency. JMD figures are approximate conversions using the displayed market rate and date. Your bank or payment provider may use a different conversion rate or apply fees.",
      "International delivery is estimated and subject to confirmation. A local courier’s separately collected charge is not included in the online total.",
    ],
  },
  {
    id: "section-5",
    title: "Third-party services and links",
    paragraphs: [
      "Links to manufacturers, payment services and messaging platforms lead to services operated by other organisations. Their terms and privacy notices apply to your use of those services. Manufacturer names and trademarks identify the relevant products and do not imply a relationship beyond any expressly stated.",
    ],
  },
  {
    id: "section-6",
    title: "Your rights and applicable law",
    paragraphs: [
      "This disclaimer does not replace the terms agreed for your purchase, the applicable product warranty, or rights and remedies that cannot lawfully be excluded. Jamaican law governs these website terms, subject to any mandatory protections that apply.",
    ],
  },
];
export default function Policy() {
  return (
    <PolicyPage
      title="Disclaimer"
      intro="How to use our product information, technical guidance and quotation tools."
      sections={sections}
    />
  );
}
